export default __webpack_public_path__ + "static/marie_barnes-e9693a07d8da0b392a5de8e2363c1be9.png";